export const config = {
  title: 'Payment Failure',
  paraTitle: 'Please try again',
  subTitle: 'Application Payment not completed',
  para1: '',
  link: '/payment',
  linkText: '',
  para2: ' ',
};
